import { AlertTriangle } from 'lucide-react';
import { TokenChipInput } from '../../components/ui/TokenChipInput';

// ⚠️⚠️ THE CONTROL THE AUTONOMOUS TRIAL RESTS ON, so it is written to be READ.
//
// The trial runs autonomous sending on the EXISTING SHARED BROADCAST NUMBER,
// where real franchisee contacts already receive messages and reply. Without
// this list the bot would answer a franchisee's "thanks" with RV sales
// conversation — from kyck, to a real client contact, unprompted and
// unreviewed. The copy here says that, because whoever edits this field is the
// person who needs to know it.

export function AllowlistEditor({
  value,
  onChange,
  mode,
}: {
  value: string[];
  onChange: (next: string[]) => void;
  mode: 'draft' | 'autonomous';
}) {
  const isLive = mode === 'autonomous';
  const isEmpty = value.length === 0;

  return (
    <div>
      <p className="text-sm font-medium">Test phone allowlist</p>
      <p className="mb-2 text-xs text-muted-foreground">
        The only numbers this bot may text without a person approving it — and, while this list
        has anything in it, the only numbers whose replies reach the bot at all. Everyone else
        is left to the ordinary broadcast handling.
      </p>

      <TokenChipInput
        value={value}
        onChange={onChange}
        placeholder="0412 345 678, then Enter"
        ariaLabel="Test phone allowlist"
      />
      <p className="mt-1 text-xs text-muted-foreground">
        Type a mobile and press Enter. Saved in international form, so it matches however the
        number arrives.
      </p>

      {isLive && isEmpty && (
        // ⚠️ An autonomous bot with an empty allowlist SENDS NOTHING. Empty does
        // not mean "anyone" — that is the whole point — but a setting that
        // silently does nothing reads as the feature being broken, so it says so.
        <div className="mt-3 flex gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
          <p>
            <strong>This bot is autonomous with an empty allowlist, so it will send nothing.</strong>{' '}
            An empty list deliberately does not mean "anyone" — it means the bot is switched off.
            Add the numbers it may text, or put it back into draft mode.
          </p>
        </div>
      )}

      {isLive && !isEmpty && (
        <div className="mt-3 flex gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
          <p>
            This bot replies <strong>automatically, with nobody reading the message first</strong>,
            to these {value.length} number{value.length === 1 ? '' : 's'}. Only add phones the
            team physically controls.
          </p>
        </div>
      )}

      {!isLive && !isEmpty && (
        <p className="mt-2 text-xs text-muted-foreground">
          This bot is in draft mode, so nothing sends on its own — the list will apply if it is
          switched to autonomous.
        </p>
      )}

      {/* ⚠️ THE TWO-DELIBERATE-ACTS RULE, on screen rather than only in the
          code. Clearing this list does not open the bot to the public; it stops
          it. Going live needs a dedicated number as well. */}
      <p className="mt-2 text-xs text-muted-foreground">
        Clearing this list does not let the bot text everyone — it stops it sending at all. Going
        live for real also needs its own phone number, which is a separate, deliberate step.
      </p>
    </div>
  );
}
